import { RouterProvider } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import "./index.css";
import router from "./routes/router";
import { Suspense } from "react";
import { useDispatch } from "react-redux";
import { setPopupState } from "reducer/globalSlice";
import SpinnerLoader from "components/UI/SpinnerLoader/SpinnerLoader";
import { NetworkProvider } from "context/NetworkContext";
import OfflineBanner from "components/UI/OfflineBanner/OfflineBanner";
import { GoogleOAuthProvider } from "@react-oauth/google";

function App() {
  const dispatch = useDispatch();
  return (
    <GoogleOAuthProvider clientId="866508159589-v8tbt28756f5nfd166vk6clln8kam9og.apps.googleusercontent.com">
      <NetworkProvider>
        <div
          className="App"
          onClick={() => dispatch(setPopupState({ id: "", value: false }))}
        >
          <OfflineBanner />
          <Suspense
            fallback={
              <div
                style={{
                  width: "100%",
                  height: "100vh",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <SpinnerLoader />
              </div>
            }
          >
            <RouterProvider router={router} />
          </Suspense>
          <Toaster position="top-right" reverseOrder={false} />
        </div>
      </NetworkProvider>
    </GoogleOAuthProvider>
  );
}

export default App;
